// (function () {
//     const fix = () => {
//         const lcpImg = document.querySelector(
//             "#content img.filled, .collection-grid img:first-of-type, " +
//                 ".product-grid img:first-of-type, main img:first-of-type"
//         );
//         if (lcpImg) {
//             lcpImg.removeAttribute("loading");
//             lcpImg.setAttribute("fetchpriority", "high");
//             lcpImg.decoding = "sync";
//         }
//     };
//     document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", fix, { once: !0 }) : fix();
// })();

(function () {
    const fix = () => {
        const lcpImg = document.querySelector(
            "#content img.filled, .collection-grid img:first-of-type, " +
            ".product-grid img:first-of-type, main img:first-of-type"
        );

        if (lcpImg) {
            if (!lcpImg.classList.contains("no-lazy")) {
                lcpImg.removeAttribute("loading");
            }

            lcpImg.setAttribute("fetchpriority", "high");
            lcpImg.decoding = "sync";
        }
    };

    document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", fix, { once: true })
        : fix();
})();

("use strict");
/*! Global scope initializations ------------------------------------------------*/
let html_tag = document.documentElement;
let root_styles = html_tag;
const UI = {
    _cache: new Map(),
    get(selector, key) {
        if (!this._cache.has(key)) {
            this._cache.set(key, document.querySelector(selector));
        }
        return this._cache.get(key);
    },
    get top_id() {
        return this.get(".shopify-section-header", "top");
    },
    get nav_top_id() {
        return this.get("#nav-top", "nav_top");
    },
    get header_outer() {
        return this.get("#header-outer", "h_outer");
    },
    get header_inner() {
        return this.get("#header-inner", "h_inner");
    },
    get header_id() {
        const o = this.header_outer;
        return o ? o.querySelector("#header") : null;
    },
    get search_id() {
        return this.get("#search", "search");
    },
    get nav_outer() {
        return this.get("#nav-outer", "nav_outer");
    },
    get nav_bar_id() {
        return this.get("#nav-bar", "nav_bar");
    },
    get nav_id() {
        return this.get("#nav", "nav_id");
    },
    get nav_main() {
        return this.nav_bar_id ?? this.nav_id;
    },
    get content_id() {
        if (!this._content) this._content = document.getElementById("content");
        return this._content;
    },
};
Object.defineProperty(window, "top_id", { get: () => UI.top_id, configurable: !0 });
Object.defineProperty(window, "nav_top_id", { get: () => UI.nav_top_id, configurable: !0 });
Object.defineProperty(window, "header_outer", { get: () => UI.header_outer, configurable: !0 });
Object.defineProperty(window, "header_inner", { get: () => UI.header_inner, configurable: !0 });
Object.defineProperty(window, "header_id", { get: () => UI.header_id, configurable: !0 });
Object.defineProperty(window, "search_id", { get: () => UI.search_id, configurable: !0 });
Object.defineProperty(window, "nav_outer", { get: () => UI.nav_outer, configurable: !0 });
Object.defineProperty(window, "nav_bar_id", { get: () => UI.nav_bar_id, configurable: !0 });
Object.defineProperty(window, "nav_id", { get: () => UI.nav_id, configurable: !0 });
Object.defineProperty(window, "nav_main", { get: () => UI.nav_main, configurable: !0 });
Object.defineProperty(window, "content_id", { get: () => UI.content_id, configurable: !0 });
const viewportWidth = window.innerWidth;
const mediaMax1000 = window.matchMedia("(max-width: 1000px)");
const mediaMin1000 = window.matchMedia("(min-width: 1001px)");
html_tag.classList.add("js");
const asyncOnce = { once: !0 };
const asyncPass = { passive: !0, once: !0 };
/*! Scheduler yield — breaks long tasks so browser can handle taps between them */
function yieldToMain() {
    if (typeof scheduler !== "undefined" && typeof scheduler.yield === "function") {
        return scheduler.yield();
    }
    return new Promise((resolve) => setTimeout(resolve, 0));
}
/*! Environment & feature detection -------------------------------------------------- */
const fp = (localPath, key) => (window.filepaths && window.filepaths[key]) || localPath;
const isMobile =
    window.matchMedia("(pointer: coarse)").matches ||
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;
html_tag.classList.add(isMobile ? "mobile" : "no-mobile");
const isShopify = () => window.Shopify === undefined || Object.keys(window.Shopify).length < 3;
const isShopifyDesignMode = () => typeof window.Shopify !== "undefined" && !!window.Shopify.designMode;
const isHasSelectorSupported = () => {
    try {
        document.querySelector(":has(*)");
        return !0;
    } catch (e) {
        return !1;
    }
};
const global_dir = html_tag.getAttribute("dir") === "rtl" ? ["rtl", !1] : ["ltr", !0];
const getHtmlTheme = (themes = ["xclusive", "xtra"]) => {
    const theme = html_tag.dataset.theme ? html_tag.dataset.theme.toLowerCase() : null;
    return theme && themes.includes(theme) ? theme : null;
};
/*! Helper Functions -------------------------------------------------- */
const initPopupRootRelocator = (function () {
    if (window.__popupRelocatorInitialized) return;
    window.__popupRelocatorInitialized = !0;
    const MOVED_ATTR = "data-popup-moved";
    function movePopupToRoot(popup, root_id) {
        if (!popup || popup.nodeType !== 1 || popup.getAttribute(MOVED_ATTR) === "1") return;
        root_id.appendChild(popup);
        popup.setAttribute(MOVED_ATTR, "1");
    }
    function relocateNow() {
        const root_id = document.getElementById("root") || document.body;
        if (!root_id || !content_id) return !1;
        content_id.querySelectorAll(".popup-a").forEach((p) => movePopupToRoot(p, root_id));
        if (!window.__popupRelocatorContentObserver && "MutationObserver" in window) {
            const obs = new MutationObserver((mutations) => {
                for (const m of mutations) {
                    for (const node of m.addedNodes) {
                        if (!node || node.nodeType !== 1) continue;
                        if (node.classList?.contains("popup-a")) {
                            movePopupToRoot(node, root_id);
                            continue;
                        }
                        node.querySelectorAll?.(".popup-a").forEach((n) => movePopupToRoot(n, root_id));
                    }
                }
            });
            obs.observe(content_id, { childList: !0, subtree: !0 });
            window.__popupRelocatorContentObserver = obs;
        }
        return !0;
    }
    if (relocateNow()) return;
    if ("MutationObserver" in window) {
        const b = new MutationObserver(() => {
            if (relocateNow()) b.disconnect();
        });
        b.observe(document.documentElement, { childList: !0, subtree: !0 });
    } else document.addEventListener("DOMContentLoaded", relocateNow, { once: !0 });
})();
const getSiblings = (el) => (el?.parentNode ? [...el.parentNode.children].filter((s) => s !== el) : []);
const append_url = (el, content, className, href, access) => {
    if (!el) return;
    const link = createElementWithClass("a", className);
    link.href = href || "#";
    if (access) {
        link.tabIndex = -1;
        link.setAttribute("aria-hidden", "true");
        link.setAttribute("focusable", "false");
    }
    link.innerHTML = content;
    el.appendChild(link);
};
// function new_css(id, href, media) {
//     if (document.getElementById(id)) return;
//     const link = document.createElement("link");
//     link.id = id;
//     link.rel = "stylesheet";
//     link.href = href;
//     link.media = media || "screen";
//     const css = document.querySelectorAll("link[id]");
//     css.length ? css[css.length - 1].after(link) : document.head.appendChild(link);
// }

function new_css(id, href, media) {
    if (document.getElementById(id)) return;

    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = href;
    link.media = media || "screen";

    document.head.appendChild(link);
}


// function loadRes(u, c, i) {
//     if (html_tag.classList.contains(i)) {
//         if (typeof c === "function") c();
//         return !0;
//     }
//     const s = document.createElement("script");
//     s.src = u;
//     s.async = !0;
//     if (typeof c === "function") s.onload = c;
//     s.onerror = () => console.warn(`Script failed: ${u}`);
//     document.body.appendChild(s);
//     html_tag.classList.add(i);
// }

/* INP optimization: the "loaded" class used to be added inside requestAnimationFrame, so two calls in
   the same frame (e.g. semanticSelect dispatched twice during a variant change) injected and executed
   the same plugin twice. The class is now added synchronously, and callbacks that arrive while the
   script is still downloading are queued and run on load instead of running before the plugin exists. */
const loadResPending = new Map();
function loadRes(u, c, i) {
    const key = String(i);
    const pending = loadResPending.get(key);
    if (pending) {
        if (typeof c === "function") pending.push(c);
        return true;
    }
    if (html_tag.classList.contains(i)) {
        if (typeof c === "function") c();
        return true;
    }

    const queue = [];
    if (typeof c === "function") queue.push(c);
    loadResPending.set(key, queue);

    const s = document.createElement("script");
    s.src = u;
    s.async = true;
    s.onload = () => {
        loadResPending.delete(key);
        for (const fn of queue) {
            try {
                fn();
            } catch (err) {
                console.error(err);
            }
        }
    };
    s.onerror = () => {
        loadResPending.delete(key);
        console.warn(`Script failed: ${u}`);
    };

    document.body.appendChild(s);
    html_tag.classList.add(i);
}



function throttle(callback, delay) {
    let timeoutId;
    return function () {
        if (!timeoutId) {
            timeoutId = setTimeout(() => {
                callback();
                timeoutId = null;
            }, delay);
        }
    };
}
function clone_with_class(el, cl1, cl2) {
    if (!el) return;
    const cln = el.cloneNode(!0);
    cln.classList.add(cl1);
    el.after(cln);
    el.classList.add(cl2);
}
function create_slider(el, settings, minSlides) {
    const imgOverlays = [];
    let bg = !1;
    const children = Array.from(el.children);
    const childrenLength = children.length;
    for (let i = 0; i < childrenLength; i++) {
        if (children[i].classList.contains("img-overlay")) {
            bg = !0;
            imgOverlays.push(children[i]);
            children[i].remove();
        }
    }
    if (childrenLength > 1) {
        if (el.tagName.toLowerCase() === "ul") {
            requestAnimationFrame(() => {
                el.setAttribute("role", "none");
                children.forEach((li) => {
                    li.setAttribute("role", "none");
                    li.classList.add("li");
                });
            });
        }
        minSlides = minSlides || 1;
        if (childrenLength > parseFloat(minSlides)) {
            let paginationClass = settings?.pagination?.el || ".swiper-pagination";
            paginationClass = paginationClass.replace(/\./g, " ").trim();
            const dots = document.createElement("span");
            dots.className = paginationClass;
            const prev = document.createElement("span");
            prev.classList.add("swiper-button-prev", "swiper-button-nav");
            const next = document.createElement("span");
            next.classList.add("swiper-button-next", "swiper-button-nav");
            el.classList.add("s4wi");
            requestAnimationFrame(() => {
                prev.setAttribute("role", "navigation");
                next.setAttribute("role", "navigation");
            });
            const slidesFragment = document.createDocumentFragment();
            children.forEach((child) => {
                const w = document.createElement("div");
                w.classList.add("swiper-slide");
                w.appendChild(child);
                slidesFragment.appendChild(w);
            });
            const swiperOuter = document.createElement("div");
            swiperOuter.className = "swiper-outer";
            const swiperWrapper = document.createElement("div");
            swiperWrapper.className = "swiper-wrapper";
            swiperWrapper.appendChild(slidesFragment);
            swiperOuter.appendChild(swiperWrapper);
            const swiperFragment = document.createDocumentFragment();
            swiperFragment.appendChild(swiperOuter);
            const pagination = document.createElement("div");
            pagination.className = "swiper-custom-pagination";
            swiperFragment.appendChild(pagination);
            if (settings?.pagination) {
                settings.pagination.el = settings.pagination.el || pagination;
                pagination.append(prev, dots, createElementWithClass("span", "swiper-custom-fraction"), next);
            } else {
                const nf = document.createDocumentFragment();
                nf.append(prev, next);
                swiperFragment.appendChild(nf);
            }
            el.appendChild(swiperFragment);
            settings.navigation = settings.navigation || {};
            settings.navigation.prevEl = prev;
            settings.navigation.nextEl = next;
            const swiperInstance = new Swiper(swiperOuter, settings);
            requestAnimationFrame(() => {
                el.querySelectorAll(".swiper-pagination-bullet").forEach((b) => b.setAttribute("role", "navigation"));
            });
            return swiperInstance;
        }
    }
    if (bg) requestAnimationFrame(() => imgOverlays.forEach((io) => el.appendChild(io)));
    return null;
}
function randomize(el) {
    el.setAttribute("data-random", Math.floor(Math.random() * 10000) + 1);
}
function assignIndex(elements) {
    const len = elements.length;

    // single style pass (no repeated recalculation risk)
    for (let i = 0; i < len; i++) {
        elements[i].style.zIndex = String(len - i);
    }
}

function createElementWithClass(tag, classList) {
    const el = document.createElement(tag);
    if (!Array.isArray(classList)) classList = [classList];
    el.classList.add(...classList);
    return el;
}
function runWhenIdle(fn) {
    "requestIdleCallback" in window ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 300);
}
function updateSliders(el) {
    if (!el.classList.contains("s4wi")) return;
    const sl_el = el.querySelector(".swiper-outer");
    if (!sl_el) return;
    new IntersectionObserver((entries) => {
        for (const e of entries) {
            if (e.isIntersecting && sl_el.swiper) {
                requestAnimationFrame(() => sl_el.swiper.updateAutoHeight());
            }
        }
    }).observe(el);
}
/*! Layout utilities -------------------------------------------------- */
let stickyOffsetCalculated = !1,
    stickyOffsetScheduled = !1,
    stickyListenersAdded = !1;
const SO_req = [".m6pr", '[id^="section-"]', ".f8ps", ".f8sr", ".m6cl", ".m6ac"];
const requiredElementsExist = SO_req.some((sel) => document.querySelector(sel));
const setStickyOffset = () =>
    html_tag.style.setProperty("--sticky_offset", `${header_outer.getBoundingClientRect().height}px`);
const setNavMainOffset = () =>
    html_tag.style.setProperty("--sticky_offset", `${nav_main.getBoundingClientRect().height}px`);
const updateSticky = () => (mediaMax1000.matches ? setStickyOffset() : mediaMin1000.matches ? setNavMainOffset() : void 0);
/* INP fix (2026-10-21): split into a read (measure) and a write (apply) step so custom-async.js can
   take this measurement in the same layout pass as its own header measurements. */
function stickyOffsetMeasure() {
    if (stickyOffsetCalculated || !nav_main || !header_outer || !header_inner || !requiredElementsExist) return null;
    if (header_inner.classList.contains("sticky-nav")) {
        html_tag.classList.add("has-sticky-nav");
        return mediaMax1000.matches
            ? header_outer.getBoundingClientRect().height
            : mediaMin1000.matches
              ? nav_main.getBoundingClientRect().height
              : -1;
    }
    return header_outer.getBoundingClientRect().height;
}
function stickyOffsetApply(h) {
    if (h === null || stickyOffsetCalculated) return;
    if (h >= 0) html_tag.style.setProperty("--sticky_offset", `${h}px`);
    if (header_inner.classList.contains("sticky-nav") && !stickyListenersAdded) {
        mediaMax1000.addEventListener("change", updateSticky);
        mediaMin1000.addEventListener("change", updateSticky);
        stickyListenersAdded = !0;
    }
    stickyOffsetCalculated = !0;
}
function stickyOffset() {
    if (stickyOffsetScheduled) return;
    stickyOffsetScheduled = !0;
    requestAnimationFrame(() => {
        stickyOffsetScheduled = !1;
        stickyOffsetApply(stickyOffsetMeasure());
    });
}
if (!isMobile) window.addEventListener("mousemove", stickyOffset, asyncOnce);
document.addEventListener("scroll", stickyOffset, asyncPass);
window.addEventListener(
    "resize",
    throttle(() => {
        stickyOffsetCalculated = !1;
        stickyOffset();
    }, 500)
);
let scrollbarWidth = null;
function getScrollbarWidth() {
    if (scrollbarWidth !== null) {
        return scrollbarWidth;
    }

    const clientWidth = document.documentElement.clientWidth;

    scrollbarWidth = Math.max(
        0,
        viewportWidth - clientWidth
    );

    requestAnimationFrame(() => {
        html_tag.style.setProperty(
            "--scrollbar_width",
            `${scrollbarWidth}px`
        );
    });

    return scrollbarWidth;
}
if (mediaMin1000.matches) {
    document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", () => runWhenIdle(getScrollbarWidth))
        : runWhenIdle(getScrollbarWidth);
}
if (isShopifyDesignMode()) window.addEventListener("resize", () => runWhenIdle(() => getScrollbarWidth(!0)));
if (header_inner) {
    if (header_inner.classList.contains("mobile-visible-search")) html_tag.classList.add("has-mobile-visible-search");
    if (header_inner.classList.contains("t1nn")) html_tag.classList.add("t1nn");
}
window.addEventListener(
    "resize",
    throttle(() => {
        customDropHeight();
        if (!header_outer || !header_inner) return;
        requestAnimationFrame(() =>
            html_tag.style.setProperty("--header_height_static", header_outer.getBoundingClientRect().height + "px")
        );
    }, 500)
);
function customDropHeight() {
    if (!nav_main) return;
    if (![".m6fr.wide-transparent", ".m6fr.size-xl", ".m6fr article.size-xl"].some((s) => document.querySelector(s)))
        return;
    requestAnimationFrame(() => {
        if (header_outer && header_inner)
            html_tag.style.setProperty("--header_height_static", header_outer.getBoundingClientRect().height + "px");
        if (nav_top_id) html_tag.style.setProperty("--nav_top_h", nav_top_id.getBoundingClientRect().height + "px");
    });
}
let logo_id = document.querySelector("#logo");
let logo_img = logo_id ? logo_id.querySelector("img") || null : null;
if (logo_img) {
    logo_img.complete ? customDropHeight() : logo_img.addEventListener("load", customDropHeight);
} else {
    customDropHeight();
}
const breadcrumb_back = document.querySelectorAll(".breadcrumb-back");
for (const el of breadcrumb_back) {
    if (document.referrer.includes(window.location.host)) {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            history.back();
        });
    } else {
        el.remove();
    }
}
function checkAndAddClass(elements, className) {
    for (const el of elements) {
        const parent = el.parentNode,
            grandparent = parent?.parentNode;
        const alone = el.previousElementSibling === null && el.nextElementSibling === null;
        if (
            alone &&
            (parent.id === "content" ||
                (parent.previousElementSibling === null &&
                    parent.nextElementSibling === null &&
                    grandparent?.id === "content"))
        ) {
            content_id.classList.add(className);
        }
    }
}
checkAndAddClass(document.getElementsByClassName("align-middle"), "align-center");
checkAndAddClass(document.getElementsByClassName("align-center"), "align-center-static");
if (!isHasSelectorSupported()) {
    document.querySelectorAll(".l4ft .content.box").forEach((el) => {
        const li = el.closest("li");
        if (li) li.classList.add("has-content-box");
    });
}
const loadMoreItemClicked = localStorage.getItem("loadMoreItemClicked");
if (loadMoreItemClicked) {
    const target = document.querySelector(
        [
            `#collection > li > figure > a[href="${loadMoreItemClicked}"]`,
            `.m6cl .results > div a[href="${loadMoreItemClicked}"]`,
            `.m6cl .results > .l4ne a[href="${loadMoreItemClicked}"]`,
        ].join(", ")
    );
    if (target && !window.location.href.includes(loadMoreItemClicked)) {
        if ("scrollRestoration" in history) history.scrollRestoration = "manual";
        target.scrollIntoView({ block: "center" });
    }
    localStorage.removeItem("loadMoreItemClicked");
}
/*! Custom Events -------------------------------------------------- */
let quickShopEvt = new CustomEvent("quickShop");
let ajaxCartEvt = new CustomEvent("ajaxCart");
let searchClassesEvt = new CustomEvent("searchClasses");
let inputPaddingEvt = new CustomEvent("inputPadding");
const transparentHeaderEvt = new CustomEvent("transparentHeaderAsync");
window.addEventListener("transparentHeaderAsync", function () {
    if (!content_id || !header_inner) return;
    const ffa = content_id.children[0];
    if (!ffa) return;
    let ffd = !1,
        ffe = !1;
    const ffc = ffa.children[0];
    if (ffa.classList.contains("shopify-section") && header_inner.hasAttribute("data-transparent")) ffd = !0;
    if (ffc && (ffc.classList.contains("m6bx") || ffc.classList.contains("m6fr")) && ffc.classList.contains("wide")) {
        ffe = !0;
        ffc.classList.add("im-tr");
    }
    if (ffd && document.querySelector('.shopify-section-header ~ [class*="shopify-section-announcement-bar"]'))
        ffd = !1;
    if (ffd && ffe && ffc?.classList.contains("wide-transparent")) {
        top_id.classList.add("transparent");
        html_tag.classList.add("has-first-m6fr-wide");
        if (ffc.classList.contains("m6bx")) html_tag.classList.add("has-first-m6bx-wide");
        html_tag.classList.toggle("has-first-flexbile-wide", ffc.classList.contains("flexible-section"));
        ffc.classList.add("is-first-m6fr-wide");
        const slides = ffa.querySelectorAll(".swiper-slide-active article");
        const firstSlide = slides.length > 0 ? slides[0] : ffa.querySelector("article");
        const palette =
            firstSlide?.getAttribute("data-color-palette") ||
            ffa.querySelector(".m6fr")?.getAttribute("data-active-content-desktop");
        if (palette) {
            setTimeout(() => {
                const base = palette.replace("_gradient", "");
                html_tag.style.setProperty("--transparent_header_fg", `var(--${base}_fg)`);
                html_tag.style.setProperty("--transparent_header_bg", `var(--${palette}_bg)`);
                html_tag.style.setProperty("--transparent_header_btn_bg", `var(--${base}_btn_bg)`);
                html_tag.style.setProperty("--transparent_header_btn_fg", `var(--${base}_btn_fg)`);
                html_tag.style.setProperty(
                    "--transparent_header_bd",
                    palette.includes("white") || palette.includes("light")
                        ? "var(--header_border_color_light)"
                        : "var(--header_border_color_dark)"
                );
            }, 0);
        }
    } else {
        header_inner.classList.remove("transparent");
        html_tag.classList.remove("has-first-m6fr-wide", "has-first-m6bx-wide");
    }
});
window.dispatchEvent(transparentHeaderEvt);
const topEvt = new CustomEvent("top");
window.addEventListener("top", function () {
    if (logo_id) {
        if (
            logo_id.parentElement?.classList.contains("text-center-logo") &&
            header_inner &&
            !header_inner.classList.contains("hide-btn") &&
            search_id
        )
            search_id.classList.add("compact");
        if (logo_id.querySelectorAll("span").length && header_inner) header_inner.classList.add("logo-text");
        const imgWithAlt = logo_id.querySelector("img[alt]");
        if (imgWithAlt) {
            const img = new Image();
            img.onload = () => {};
            img.onerror = () =>
                requestAnimationFrame(() => {
                    const s = document.createElement("span");
                    s.innerHTML = imgWithAlt.alt;
                    imgWithAlt.parentNode.appendChild(s);
                    imgWithAlt.parentNode.classList.add("broken-img");
                });
            img.src = imgWithAlt.src;
        }
    }
    let calcLogoOffsetScheduled = !1;
    function calcLogoOffset() {
        if (calcLogoOffsetScheduled) return;
        calcLogoOffsetScheduled = !0;
        requestAnimationFrame(() => {
            if (header_id && logo_id && header_inner.classList.contains("text-center-logo"))
                html_tag.style.setProperty(
                    "--logo_offset",
                    (logo_id.offsetLeft / header_id.getBoundingClientRect().width) * 100 + "%"
                );
            calcLogoOffsetScheduled = !1;
        });
    }
    if (nav_id?.classList.contains("no-wide")) top_id.classList.add("has-no-wide");
    if (nav_bar_id?.classList.contains("no-wide")) top_id.classList.add("has-no-wide");
    function checkInv(el, ratio) {
        requestAnimationFrame(() => {
            const r = el.getBoundingClientRect();

            const off = global_dir[1] === false
                ? viewportWidth - r.left - r.width
                : r.left;

            el.classList.toggle("inv", off > viewportWidth * ratio);
        });

    }
    function countNavDist(el, em, nav) {
        const dc = el.dataset.copy,
            show = nav.querySelector(`.show-all li[data-copy="${dc}"]`);
        if (el.classList.contains("temp-hidden")) {
            el.classList.remove("temp-hidden");
            show?.classList.remove("temp-hidden");
        }
        const wdth = el.getBoundingClientRect().width,
            nwth = nav.getBoundingClientRect().width;
        const off = global_dir[1] === !1 ? nwth - el.offsetLeft - wdth : el.offsetLeft;
        const hcnt = el.parentElement.querySelectorAll(".temp-hidden:not(.show-all)").length;
        const hide = nwth < off + wdth + wdth + em * (hcnt > 0 ? 1.2 : 0) + 10;
        el.classList.toggle("temp-hidden", hide);
        show?.classList.toggle("temp-hidden", hide);
    }


    function countNavDistF(el, em, en, nav) {
        let mdc = null,
            resizeAttached = !1;


function calcNav() {
    if (!mediaMin1000.matches) return;

    if (mdc === null) {
        const styles = getComputedStyle(el);
        const mdm = Math.abs(
            parseFloat(styles.getPropertyValue("margin-right"))
        );

        mdc =
            (nav.classList.contains("text-justify") ||
                nav.classList.contains("have-text-justify")) &&
            !isNaN(mdm)
                ? mdm
                : 0;
    }

    const rc = (orig, repl) => {
        if (nav.classList.contains(orig)) {
            nav.classList.remove(orig);
            nav.classList.add(repl);
        }
    };

    // Batch layout reads
    const elWidth = el.clientWidth;
    const navWidth = nav.clientWidth;

    if (!(elWidth > navWidth + mdc)) {
        rc("have-text-center", "text-center");
        rc("have-text-justify", "text-justify");
        rc("have-text-end", "text-end");
    } else {
        rc("text-center", "have-text-center");
        rc("text-justify", "have-text-justify");
        rc("text-end", "have-text-end");

        if (em.length) {
            en = em[0].getBoundingClientRect().width;
        }

        const ch = Array.from(el.children);

        const hr = () => {
            requestAnimationFrame(() => {
                ch.forEach((eo) => countNavDist(eo, en, nav));
            });
        };

        hr();

        if (!resizeAttached) {
            window.addEventListener("resize", throttle(hr, 100));
            resizeAttached = true;
        }
    }
}



        calcNav();
        mediaMin1000.addEventListener("change", calcNav);
    }



    const navs = document.querySelectorAll("#nav, #nav-bar");
    if (navs.length) {
        if (nav_outer) top_id.classList.add("has-nav-outer");
        navs.forEach((nav_main) => {
            if (nav_main.closest("#header-inner")) html_tag.classList.add("has-inside-nav");
            const nmu = nav_main.querySelector("[data-type]");
            if (!nmu) return;
            Array.from(nmu.children).forEach((el, i) => el.setAttribute("data-copy", nmu.children.length - i));
            const nml = nmu.querySelector("li.show-all");
            if (nml) {
                const sub = createElementWithClass("ul", "show-all-submenu");
                nml.appendChild(sub);
                for (const el of nml.closest("ul").children) {
                    if (!el.classList.contains("show-all")) sub.appendChild(el.cloneNode(!0));
                }
                const markReady = () => {
                    top_id?.classList.add("ready");
                    header_id?.classList.add("ready");
                    header_outer?.classList.add("ready");
                };
                const updateNav = () => {
                    calcLogoOffset();
                    countNavDistF(nmu, nml, 0, nav_main);
                    markReady();
                };
                const initLogLoad = () => {
                    logo_img
                        ? logo_img.complete
                            ? updateNav()
                            : logo_img.addEventListener("load", updateNav, { once: !0 })
                        : updateNav();
                };
                if (nav_outer) {
                    calcLogoOffset();
                    setTimeout(initLogLoad, 250);
                } else {
                    setTimeout(() => {
                        countNavDistF(nmu, nml, 0, nav_main);
                        header_outer.classList.add("ready");
                    }, 250);
                }
                window.addEventListener(
                    "resize",
                    throttle(() => {
                        calcLogoOffset();
                        header_outer.classList.remove("ready");
                        countNavDistF(nmu, nml, 0, nav_main);
                        header_outer.classList.add("ready");
                    }, 250)
                );
            }
            const nmv = nav_main.getElementsByClassName("sub-static");
            if (nmv.length) {
                let done = !1;
                const run = () => {
                    if (!done) {
                        Array.from(nmv).forEach((el) => checkInv(el, 0.5));
                        done = !0;
                    }
                };
                window.addEventListener("mousemove", run);
                window.addEventListener(
                    "resize",
                    throttle(() => {
                        done = !1;
                        run();
                    }, 500)
                );
            }
            nav_main.querySelectorAll('a[href="#"]:not(.toggle)').forEach((el) => {
                if (el.parentElement) el.parentElement.classList.add("empty-url");
            });
        });
    }
    if (search_id && header_inner) {
        if (search_id.classList.contains("no-bg") && !search_id.classList.contains("bd-b"))
            top_id.classList.add("no-bd-m");
        if (search_id.classList.contains("no-bg")) top_id.classList.add("no-bd");
        if (search_id.classList.contains("no-pd-t")) top_id.classList.add("no-pd-t");
        if (
            !search_id.classList.contains("compact") &&
            header_inner.classList.contains("hide-btn") &&
            header_inner.classList.contains("text-center-logo")
        ) {
            search_id.classList.add("not-compact");
            const upd = () =>
                mediaMax1000.matches ? search_id.classList.add("compact") : search_id.classList.remove("compact");
            upd();
            mediaMax1000.addEventListener("change", upd);
            mediaMin1000.addEventListener("change", upd);
        }
    }
    if (search_id) {
        if (search_id.classList.contains("compact-handle")) {
            html_tag.classList.add("t1sh-mobile", "search-compact-handle");
        } else {
            html_tag.classList.remove("t1sh-mobile", "search-compact-handle");
        }
        if (search_id.classList.contains("compact-handle-mobile")) {
            html_tag.classList.add("t1sh-mobile", "search-compact-handle", "search-compact-handle-mobile");
        } else {
            html_tag.classList.remove("search-compact-handle-mobile");
        }
        if (search_id.classList.contains("compact")) {
            search_id.classList.contains("compact-handle")
                ? html_tag.classList.add("t1sh")
                : html_tag.classList.remove("t1sh");
            html_tag.classList.add("t1sr");
        } else {
            html_tag.classList.remove("t1sr", "t1sh");
        }
        html_tag.classList.toggle("search-compact-is-centered", search_id.classList.contains("text-center-sticky"));
    }
    const accessible_css = fp("styles/theme-accessible.css", "theme_accessible_css");
    const a_accessible = document.getElementsByClassName("link-accessible");
    function accessibleLink() {
        const isActive = html_tag.classList.contains("t1ac");
        if (isActive) {
            html_tag.classList.remove("t1ac");
            Cookies.set("accessible", "no");
        } else {
            new_css("accessible-mode-css", accessible_css);
            html_tag.classList.add("t1ac");
            Cookies.set("accessible", "yes");
        }
        if (nav_id || nav_bar_id) {
            setTimeout(() => {
                for (const el of nav_main.getElementsByClassName("temp-hidden")) el.classList.remove("temp-hidden");
                window.dispatchEvent(new Event("resize"));
            }, 100);
        }
    }
    if (a_accessible.length) {
        for (const el of a_accessible) {
            if (el.parentElement && !el.parentElement.classList.contains("has-link-accessible"))
                el.parentElement.classList.add("has-link-accessible");
        }
        html_tag.addEventListener("click", (e) => {
            const l = e.target.closest("a.link-accessible");
            if (l) {
                accessibleLink();
                e.preventDefault();
            }
        });
        html_tag.addEventListener("keyup", (e) => {
            if (e.key === " " || e.key === "Enter") {
                const l = e.target.closest("a.link-accessible");
                if (l) {
                    accessibleLink();
                    e.preventDefault();
                }
            }
        });
    }
    if (Cookies.get("accessible") === "yes") {
        new_css("accessible-mode-css", accessible_css);
        html_tag.classList.add("t1ac");
    } else {
        html_tag.classList.remove("t1ac");
        Cookies.remove("accessible");
    }
});
window.dispatchEvent(topEvt);
const backgroundEvt = new CustomEvent("background");
window.addEventListener("background", function () {
    document.querySelector("#background.done")?.remove();
    const bg = document.getElementById("background");
    if (
        bg &&
        !bg.classList.contains("static") &&
        (bg.parentNode.id === "content" || bg.parentNode.classList.contains("shopify-section"))
    ) {
        const root = document.getElementById("root") || document.body;
        if (root_id) {
            root_id.appendChild(bg);
            bg.classList.add("done");
        }
    }
});
window.dispatchEvent(backgroundEvt);
/*!=== All events below are DEFERRED — registered now, dispatched later ============*/
const inputPaddingsEvt = new CustomEvent("inputPaddings");
window.addEventListener("inputPaddings", function () {
    const inputs = document.querySelectorAll('[class*="input-"][class*="fix"]');
    if (!inputs.length) return;

    const io = new IntersectionObserver(
        (entries, obs) => {
            for (const e of entries) {
                if (!e.isIntersecting) continue;

                const prefix = e.target.querySelector("span:first-child");
                const sibling = prefix?.nextElementSibling;


if (prefix && sibling) {
    requestAnimationFrame(() => {
        const width = prefix.getBoundingClientRect().width;

        sibling.style.setProperty("--pdi", width + "px");
    });
}


                obs.unobserve(e.target);
            }
        },
        { root: null, threshold: 0 }
    );

    inputs.forEach((el) => io.observe(el));
});


const moduleTabsEvt = new CustomEvent("moduleTabs");
window.addEventListener("moduleTabs", function () {
    if (typeof semanticTabs !== "function") return;
    document.querySelectorAll("#content, .m6pn").forEach((c) => {
        for (const t of c.getElementsByClassName("m6tb")) semanticTabs(t);
    });
});
let moduleFeaturedResize = !1;
const moduleFeaturedSliderEvt = new CustomEvent("moduleFeaturedSlider");
window.addEventListener("moduleFeaturedSlider", function () {
    const module_featured = document.querySelectorAll(".m6fr:not(.s4wi)");
    if (!module_featured.length) return;
    for (const el of module_featured) {
        const total_sl = el.children.length;
        const ptype = el.classList.contains("slider-fraction") ? "fraction" : "bullets";
        const ap = el.dataset.autoplay ? { delay: parseFloat(el.dataset.autoplay), pauseOnMouseEnter: !0 } : !1;
        if (!isHasSelectorSupported())
            el.querySelectorAll("figure").forEach((em) => {
                if (em.querySelectorAll("picture").length > 1) em.classList.add("has-pics");
            });
        randomize(el);
        const rid = el.dataset.random;
        const fs = create_slider(el, {
            direction: "horizontal",
            loop: !0,
            autoHeight: !0,
            resizeObserver: !0,
            autoplay: ap,
            threshold: 50,
            pagination: {
                el: `.swiper-pagination-${rid}`,
                clickable: !0,
                type: ptype,
                renderBullet: (i, c) => `<span class="${c}">${i + 1}<span class="prg"></span></span>`,
                renderFraction: (c, t) =>
                    `<span class="${c}"></span><span class="slash">/</span><span class="${t}"></span>`,
            },
            on: {
                afterInit: (s) => {
                    upd(s);
                    updateSliders(el);
                },
                slideChangeTransitionStart: (s) => upd(s),
                resize: (s) => {
                    if (isShopifyDesignMode()) for (let i = 0; i < s.slides.length; i++) s.slideNext(0);
                    setTimeout(() => {
                        if (s && typeof s.updateAutoHeight === "function") s.updateAutoHeight();
                    }, 500);
                },
            },
        });
        function upd(s) {
            el.querySelectorAll(".swiper-slide > article.aside").forEach((a) =>
                a.parentNode.classList.add("has-aside")
            );
            const aa = s.el.querySelector(".swiper-slide-active > article");
            el.dataset.activeContent = aa?.className || "";
            el.classList.toggle("changed", s.realIndex > 0);
            el.classList.toggle("last-slide-active", s.realIndex + 1 === total_sl);
        }
        if (fs && el.dataset.autoplay && !el.classList.contains("no-controls") && el.dataset.playPauseBound !== "1") {
            el.dataset.playPauseBound = "1";
            append_url(el, "Play/Pause", "play-pause");
            const pp = el.querySelector(".play-pause");
            const toggle = () => {
                const p = el.classList.toggle("paused");
                p ? fs.autoplay.stop() : fs.autoplay.start();
            };
            if (pp)
                pp.addEventListener("click", (e) => {
                    e.preventDefault();
                    toggle();
                });
            el.addEventListener("mouseleave", () => {
                if (!el.classList.contains("paused")) fs.autoplay.start();
            });
        }
        setTimeout(() => {
            if (fs && typeof fs.updateAutoHeight === "function") fs.updateAutoHeight();
        }, 500);
    }
    if (!moduleFeaturedResize) {
        moduleFeaturedResize = !0;
        window.addEventListener(
            "resize",
            throttle(() => document.documentElement.classList.add("resized"), 200),
            !0
        );
    }
});
const listTestimonialsSliderEvt = new CustomEvent("listTestimonialsSlider");
window.addEventListener("listTestimonialsSlider", function () {
    const list = document.querySelectorAll(".l4ts:not(.s4wi)");
    if (!list.length) return;
    for (const el of list) {
        let ln = [1, 2, 3];
        if (el.classList.contains("wide") || el.classList.contains("width-100")) ln = [1, 1, 1];
        if (el.classList.contains("width-50")) ln = [1, 2, 2];
        const ptype = el.classList.contains("slider-fraction") ? "fraction" : "bullets";
        const ap = el.getAttribute("data-autoplay");
        const auto = ap ? { delay: parseFloat(ap), pauseOnMouseEnter: !0, disableOnInteraction: !1 } : !1;
        randomize(el);
        const rid = el.getAttribute("data-random");
        const total = el.children.length;
        const opts = {
            direction: "horizontal",
            loop: !0,
            autoHeight: !0,
            spaceBetween: 16,
            slidesPerView: ln,
            slidesPerGroup: ln,
            autoplay: auto,
            loopAddBlankSlides: !1,
            pagination: {
                el: `.swiper-pagination-${rid}`,
                clickable: !0,
                type: ptype,
                renderFraction: (c, t) =>
                    `<span class="${c}"></span><span class="slash">/</span><span class="${t}"></span>`,
            },
            on: {
                slideChangeTransitionStart(s) {
                    s.el.parentNode.classList.toggle("changed", s.realIndex > 0);
                    s.el.parentNode.classList.toggle("last-slide-active", s.realIndex + 1 === total);
                },
            },
            breakpoints: {
                0: { slidesPerView: ln[0], slidesPerGroup: ln[0] },
                760: { slidesPerView: ln[1], slidesPerGroup: ln[1] },
                1000: { slidesPerView: ln[2], slidesPerGroup: ln[2] },
            },
        };
        if (el.classList.contains("slider") && el.children.length > ln[2]) create_slider(el, opts);
        if (el.classList.contains("slider-mobile") && el.children.length > ln[0]) {
            const ns = el.nextElementSibling;
            if (ns?.matches(".l4ts.mobile-only")) {
                ns.hasAttribute("id") && ns.removeAttribute("id");
                create_slider(ns, opts);
            }
        }
    }
});
const listStaticSliderEvt = new CustomEvent("listStaticSlider");
window.addEventListener("listStaticSlider", function () {
    const list = document.querySelectorAll(".l4st:not(.static, .s4wi)");
    if (!list.length) return;
    for (const el of list) {
        const total = el.children.length,
            ptype = el.classList.contains("slider-fraction") ? "fraction" : "bullets";
        const ap = el.getAttribute("data-autoplay");
        const auto = ap ? { delay: parseFloat(ap), pauseOnMouseEnter: !0, disableOnInteraction: !1 } : !1;
        randomize(el);
        const rid = el.getAttribute("data-random");
        clone_with_class(el, "mobile-only", "mobile-hide");
        const ne = el.nextElementSibling;
        if (ne?.classList.contains("mobile-only")) {
            ne.removeAttribute("id");
            create_slider(ne, {
                direction: "horizontal",
                loop: !0,
                autoHeight: !0,
                spaceBetween: 16,
                autoplay: auto,
                pagination: {
                    el: `.swiper-pagination-${rid}`,
                    clickable: !0,
                    type: ptype,
                    renderFraction: (c, t) =>
                        `<span class="${c}"></span><span class="slash">/</span><span class="${t}"></span>`,
                },
                on: {
                    slideChangeTransitionStart: (s) => {
                        s.el.parentNode.classList.toggle("changed", s.realIndex > 0);
                        s.el.parentNode.classList.toggle("last-slide-active", s.realIndex + 1 === total);
                    },
                },
            });
        }
    }
});
function bindInlineSlideNext(el) {
    if (!el || el.dataset.inlineNextBound === "1") return;
    el.dataset.inlineNextBound = "1";
    el.addEventListener("click", (e) => {
        const l = e.target.closest(".swiper-button-next");
        if (!l || !l.closest(".swiper-slide")) return;
        e.preventDefault();
        const so = el.querySelector(".swiper-outer");
        if (so?.swiper) so.swiper.slideNext();
    });
}
const listUspSliderEvt = new CustomEvent("listUspSlider");
window.addEventListener("listUspSlider", function () {
    const list = document.querySelectorAll(".l4us:not(.l4us-initialized)");
    if (!list.length) return;
    for (const el of list) {
        if (el.closest(".m6kn")) continue;
        el.classList.add("l4us-initialized");
        if (el.classList.contains("static") || el.classList.contains("mobile-static")) continue;
        const ap = el.hasAttribute("data-autoplay")
            ? { delay: parseFloat(el.getAttribute("data-autoplay")), pauseOnMouseEnter: !0, disableOnInteraction: !1 }
            : !1;
        const sb = el.classList.contains("no-arrows") ? 16 : 44;
        let spv = 1;
        if (el.closest("#nav-top") && el.classList.contains("slider")) {
            el.classList.add("slider-in-header");
            if (!el.classList.contains("slider-single")) spv = "auto";
        }
        if (el.querySelectorAll("li").length === 1) el.classList.remove("slider", "slider-single");
        const opts = {
            direction: "horizontal",
            loop: !0,
            pagination: !1,
            autoplay: ap,
            slidesPerView: spv,
            autoHeight: !0,
            spaceBetween: sb,
            breakpoints: {
                0: { slidesPerView: 1 },
                760: { slidesPerView: spv },
                1000: { spaceBetween: sb },
                1100: { spaceBetween: 20 },
            },
        };
        if (el.classList.contains("slider")) {
            create_slider(el, opts);
            bindInlineSlideNext(el);
        } else if (el.children.length > 1) {
            clone_with_class(el, "l4us-mobile", "mobile-hide");
            const ne = el.nextElementSibling;
            if (ne?.classList.contains("l4us-mobile")) {
                ne.classList.remove("slider", "slider-in-header");
                ne.hasAttribute("id") && ne.removeAttribute("id");
                create_slider(ne, opts);
                bindInlineSlideNext(ne);
            }
        }
    }
});
function createRatingsHtmlElement(rating, total) {
    const re = createElementWithClass("span", "rating");
    const sp = rating.toString().split(".");
    let ir = +sp[0],
        id = +sp[1] || 0;
    const cs = (p) => {
        const s = createElementWithClass("span", "star"),
            f = createElementWithClass("span", "fill");
        f.style.width = p + "%";
        s.appendChild(f);
        return s;
    };
    for (let i = 1; i <= total; i++) {
        if (i <= ir) re.appendChild(cs(100));
        else if (id > 0) {
            re.appendChild(cs((id + "0").substr(0, 2)));
            id = 0;
        } else re.appendChild(cs(0));
    }
    return re;
}
const ratingsEvt = new CustomEvent("ratings");
window.addEventListener("ratings", function () {
    const els = document.querySelectorAll("[data-val][data-of]:not(.rating-initialized)");
    if (!els.length) return;
    for (const el of els) {
        el.classList.add("rating-initialized");
        const frag = document.createDocumentFragment(),
            lbl = createElementWithClass("span", "rating-label");
        const notBar = !(el.classList.contains("s1ld") || el.classList.contains("s1br"));
        if (notBar) {
            frag.appendChild(createRatingsHtmlElement(el.dataset.val, el.dataset.of));
            lbl.innerHTML = el.innerHTML;
        } else {
            lbl.innerHTML = `<span class="bar" style="width:${(el.dataset.val / el.dataset.of) * 100}%;"></span>`;
        }
        frag.appendChild(lbl);
        el.textContent = "";
        el.appendChild(frag);
    }
});
const mediaFlexibleEvt = new CustomEvent("mediaFlexbile");
window.addEventListener("mediaFlexbile", function () {
    const els = document.querySelectorAll(".media-flexible:not(.media-flexible-initialized)");
    if (!els.length) return;
    for (const el of els) {
        const par = el.parentElement;
        if (el.classList.contains("media-flexible-initialized") || par.classList.contains("flexible-stack")) continue;
        if (!(el.classList.contains("slider-mobile") || par.classList.contains("mobile-static"))) continue;
        if (!par.getElementsByClassName("media-flexible-mobile").length) {
            const tag = document.createElement("div");
            tag.classList.add("media-flexible-mobile");
            el.after(tag);
            el.classList.add("mobile-hide");
            const cm = par.querySelector(".media-flexible-mobile");
            par.querySelectorAll(
                ".media-flexible:not(.mobile-hide-media-flexible) > *:not(.mobile-hide-media-flexible)"
            ).forEach((c) => cm.appendChild(c.cloneNode(!0)));
            cm.classList.remove("media-flexible", "mobile-hide");
            cm.hasAttribute("id") && cm.removeAttribute("id");
            Array.from(cm.children).forEach((c) => {
                if (c.classList.contains("mobile-hide")) c.remove();
            });
            randomize(cm);
            const rid = cm.getAttribute("data-random");
            if (!cm.classList.contains("s4wi")) {
                create_slider(cm, {
                    direction: "horizontal",
                    loop: !0,
                    autoHeight: !0,
                    pagination: {
                        el: ".swiper-pagination-" + rid,
                        clickable: !0,
                        type: "bullets",
                        renderBullet: (i, c) => `<span class="${c}">${i + 1}<span class='prg'></span></span>`,
                    },
                    on: {
                        slideChangeTransitionStart: (s) => {
                            const ac = s.el.querySelector(
                                `.swiper-slide[data-swiper-slide-index="${s.realIndex}"] > *`
                            );
                            if (ac) {
                                const cs = el.closest(".m6fr");
                                if (cs) cs.setAttribute("data-active-content", ac.getAttribute("data-color-palette"));
                            }
                        },
                    },
                });
            }
        }
        el.classList.add("media-flexible-initialized");
    }
});
const createColsEvt = new CustomEvent("createCols");
window.addEventListener("createCols", function () {
    const spe = document.querySelector('[id$="page-service-info-blocks"]');
    if (!spe) return;
    const par = spe.parentElement;
    if (par.classList.contains("cols")) {
        const a = par.querySelector("article.w64.t55");
        if (a) a.replaceWith(...a.childNodes);
        par.replaceWith(...par.childNodes);
    }
    const wrap = document.createElement("div");
    wrap.classList.add("cols", "section-width-boxed");
    const wi = document.createElement("article");
    wi.classList.add("w64", "t55");
    wrap.appendChild(wi);
    const ps = [
        "shopify-section-page-service-menu",
        "shopify-section-faq",
        "shopify-section-contact-form",
        "shopify-section-google-maps",
    ];
    let any = !1;
    const find = () => {
        const prev = spe.previousElementSibling;
        if (!prev) return;
        let f = !1;
        for (const c of ps)
            if (prev.classList.contains(c)) {
                f = !0;
                any = !0;
                prev.classList.add("w64", "t55");
                wi.appendChild(prev);
            }
        if (f) {
            find();
        } else if (any) {
            for (let i = 1; i < wi.childNodes.length; i++) wi.insertBefore(wi.childNodes[i], wi.firstChild);
            spe.parentNode.insertBefore(wrap, spe);
            wrap.appendChild(spe);
        }
    };
    find();
});
const showAlertEvt = new CustomEvent("showAlert");
window.addEventListener(
    "showAlert",
    function (event) {
        if (!event?.detail?.message) return;
        const { message: mt, type: tp, header: h, origin: o } = event.detail;
        const mo = o ? `message-${o}` : !1;
        const tm = {
            success: { color: "lime", def: window.translations?.general_alerts_success_text || "Success" },
            info: { color: "pine", def: window.translations?.general_alerts_info_text || "Info" },
            error: { color: "rose", def: window.translations?.general_alerts_error_text || "Error" },
        };
        const { color: mc, def: def } = tm[tp] || { color: "lime", def: "" };
        const mh = h || def;
        let la = document.querySelector(".l4al:not(.inline):not(.l4al-trustbadge)");
        if (!la) {
            la = document.createElement("ul");
            la.classList.add("l4al", "fixed");
            (document.getElementById("root") || document.body).appendChild(la);
        }
        if (!mo || la.getElementsByClassName(mo).length === 0) {
            const t = document.createElement("div");
            t.innerHTML =
                `<li class="overlay-${mc} ${mo || ""}"><i aria-hidden="true" class="icon-${tp}"></i><p class="strong">${mh}</p><p>${mt}</p><a href="#" class="close">Close</a></li>`.trim();
            if (t.firstElementChild) la.appendChild(t.firstElementChild);
        }
        if (typeof alertsEvt !== "undefined") window.dispatchEvent(alertsEvt);
    },
    !1
);
const lazyVideoEvt = new CustomEvent("lazyVideo");
window.addEventListener("lazyVideo", function () {
    const vs = Array.from(document.querySelectorAll("video.lazy"));
    if (!vs.length || !("IntersectionObserver" in window)) return;
    const obs = new IntersectionObserver((entries, o) => {
        for (const e of entries) {
            if (!e.isIntersecting) continue;
            const v = e.target;
            for (const s of v.children) if (s.tagName.toLowerCase() === "source") s.src = s.dataset.src;
            v.load();
            v.classList.remove("lazy");
            o.unobserve(v);
        }
    });
    vs.forEach((v) => obs.observe(v));
});
const check_limit_event = new CustomEvent("check-limit-event");
window.addEventListener("check-limit-event", function () {
    const els = document.querySelectorAll(".check[data-limit]");
    if (!els.length) return;
    for (const el of els) {
        if (el.classList.contains("check-limit-initialized")) continue;
        el.classList.add("check-limit-initialized");
        const tl = el.tagName.toLowerCase() === "ul" || el.tagName.toLowerCase() === "ol" ? "li" : "a";
        const li = createElementWithClass(tl, "limit"),
            idx = parseInt(el.dataset.limit, 10) - 1,
            tr = el.children[idx];
        if (!tr) continue;
        Array.from(tr.parentNode.children)
            .slice(idx + 1)
            .forEach((em) => {
                if (!em.classList.contains("hidden")) em.classList.add("hidden-check");
            });
        li.innerText = `+${Math.abs(el.querySelectorAll("li:not(.hidden,.tip-cont)").length - el.dataset.limit)}`;
        if (tl === "li") {
            const a = document.createElement("a");
            a.href = "./";
            while (li.firstChild) a.appendChild(li.firstChild);
            li.appendChild(a);
        }
        el.append(li);
        const ld = el.querySelector("li.hidden");
        if (ld) el.appendChild(ld);
    }
});

const listCollectionEvt = new CustomEvent("listCollection");

window.addEventListener("listCollection", () => {
    const list = document.querySelectorAll(".l4cl");
    if (!list.length) return;

const run = () => {
    const hasSelectorSupport = isHasSelectorSupported();
    const classUpdates = [];

    const items = [...list];
    let index = 0;

    function processChunk() {
        const end = Math.min(index + 20, items.length);

        for (; index < end; index++) {
            const el = items[index];

            if (el.scrollHeight > el.clientHeight) {
                classUpdates.push([el, "is-scrollable"]);
            }

            if (!hasSelectorSupport) {
                el.querySelectorAll(".small a").forEach((a) => {
                    classUpdates.push([a, "has-link"]);
                });

                [
                    { sel: "div.box", cls: "has-div-box" },
                    { sel: '[class*="l4ml"]', cls: "has-l4ml" },
                    { sel: "picture ~ picture", cls: "has-picture-picture" },
                ].forEach(({ sel, cls }) => {
                    el.querySelectorAll(sel).forEach((em) => {
                        const li = em.closest("li");
                        if (li) classUpdates.push([li, cls]);
                    });
                });
            }
        }

        if (index < items.length) {
            requestAnimationFrame(processChunk);
        } else {
            requestAnimationFrame(() => {
                classUpdates.forEach(([node, cls]) => {
                    node.classList.add(cls);
                });
            });
        }
    }

    processChunk();
};

    if ("requestIdleCallback" in window) {
        requestIdleCallback(run);
    } else {
        setTimeout(run, 0);
    }
});



const listCollectionSliderEvt = new CustomEvent("listCollectionSlider");
/* INP: each Swiper init forces a full-page style recalculation. Sliders are now built only when they
   come near the viewport (or immediately if already near it), instead of all of them on page load. */
const bwSliderIO = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        bwSliderIO.unobserve(entry.target);
        bwInitCollectionSlider(entry.target);
    });
}, { rootMargin: "600px 0px" }) : null;
function bwInitCollectionSlider(el) {
        if (el.classList.contains("s4wi")) return;
        const ct = el.closest(".m6tb"),
            hf = !!el.querySelector("figure:not(:last-child)"),
            cls = el.classList;
        const computed = getComputedStyle(el);
        const dav = computed.getPropertyValue("--dist_a").trim(),
            rv = computed.getPropertyValue("--row").trim();
        const row = rv ? parseFloat(rv) : NaN;
        let sp = 16;
        if (dav && dav !== "px") {
            const d = parseFloat(dav);
            if (!isNaN(d)) sp = d;
        }
        let loop = cls.contains("slider-loop"),
            ah = cls.contains("align-stretch") || cls.contains("variable-height");
        let at = cls.contains("static-height") || cls.contains("align-center") || cls.contains("align-stretch"),
            at760 = !cls.contains("mobile-compact");
        let apm = !1,
            aps = 300;
        if (!hf) el.classList.add("no-img");
        if (cls.contains("autoplay")) {
            apm = { delay: 0 };
            loop = !0;
            aps = el.children.length * 1000;
        }
        let items = [5, 5, 3];
        if (cls.contains("text-justify") || cls.contains("auto-width")) {
            items = ["auto", "auto", "auto"];
            ah = !1;
        } else {
            const rim = {
                12: [12, 6, 4],
                11: [11, 6, 4],
                10: [10, 6, 4],
                9: [9, 6, 4],
                8: [8, 6, 4],
                7: [7, 6, 4],
                6: [6, 5, 3],
                5: [5, 5, 3],
                4: [4, 4, 3],
                3: [3, 3, 3],
                2: [2, 2, 2],
            };
            if (!Number.isNaN(row) && rim[row]) {
                items = rim[row];
            } else {
                const im = {
                    "in-col": [4, 4, 3],
                    w8: [12, 6, 4],
                    w9: [11, 6, 4],
                    w10: [10, 6, 4],
                    w11: [9, 6, 4],
                    w12: [8, 6, 4],
                    w14: [7, 6, 4],
                    w16: [6, 5, 3],
                    w20: [5, 5, 3],
                    w25: [4, 4, 3],
                    w33: [3, 3, 3],
                    w50: [2, 2, 2],
                };
                for (const c in im)
                    if (cls.contains(c)) {
                        items = im[c];
                        break;
                    }
            }
        }
        // const hi = () => {
        //     if (!hf) return;
        //     const f = el.querySelector(".swiper-slide-active figure");
        //     if (f && f.offsetHeight > 0) el.style.setProperty("--fih", f.offsetHeight + "px");
        //     else el.style.removeProperty("--fih");
        // };
        const hi = () => {
            if (!hf) return;

            requestAnimationFrame(() => {
                const f = el.querySelector(".swiper-slide-active figure");
                if (!f) {
                    el.style.removeProperty("--fih");
                    return;
                }

                const height = f.getBoundingClientRect().height;

                if (height)
                    el.style.setProperty("--fih", `${height}px`);
                else
                    el.style.removeProperty("--fih");
            });
        };


        randomize(el);
        const rid = el.getAttribute("data-random");
        create_slider(el, {
            direction: "horizontal",
            loop,
            autoHeight: ah,
            slidesPerView: items[0],
            focusableElements: "input",
            spaceBetween: sp,
            touchStartPreventDefault: !1,
            lazy: { loadPrevNext: !0 },
            pagination: { el: `.swiper-pagination-${rid}`, clickable: !0 },
            autoplay: apm,
            speed: aps,
            breakpoints: {
                0: { simulateTouch: !1, allowTouchMove: !1 },
                760: { slidesPerView: items[2], simulateTouch: at760, allowTouchMove: at760 },
                1000: { slidesPerView: items[1], simulateTouch: at, allowTouchMove: at },
                1100: { slidesPerView: items[0], simulateTouch: at, allowTouchMove: at },
            },
            on: {
                afterInit(s) {
                    if (ct) setTimeout(hi, 100);
                    if (typeof lazyVideoEvt !== "undefined") window.dispatchEvent(lazyVideoEvt);
                    updateSliders(el);
                    hi();
                },
                resize: throttle(hi, 100),
                transitionStart(s) {
                    s.el.classList.add("transition");
                },
                transitionEnd(s) {
                    s.el.classList.remove("transition");
                    hi();
                },
            },
        });
        el.querySelectorAll(".has-text,.cols").forEach((em) => {
            const p = em.parentElement;
            if (em.classList.contains("has-text")) p.classList.add("has-text");
            if (em.classList.contains("cols")) p.classList.add("has-cols");
        });
        if (hf && ct && ct.children.length)
            ct.querySelectorAll("a").forEach((l) => l.addEventListener("click", () => setTimeout(hi, 100)));
        if (hf) {
            const sub = el.closest("li.sub");
            if (sub) sub.addEventListener("mouseenter", () => setTimeout(hi, 100));
        }
        el.querySelectorAll(".swiper-wrapper[id],.swiper-button-nav[aria-controls]").forEach((n) => {
            n.removeAttribute("id");
            n.removeAttribute("aria-controls");
        });
}
window.addEventListener("listCollectionSlider", async () => {
    const list = document.querySelectorAll(".l4cl.slider:not(.s4wi), .l4ft.slider:not(.s4wi)");
    if (!list.length) return;
    const vh = window.innerHeight || 800;
    for (const el of list) {
        if (el.closest(".popup-a")) {
            el.classList.add("in-popup");
            continue;
        }
        if (bwSliderIO) {
            const r = el.getBoundingClientRect();
            const near = r.width > 0 && r.height > 0 && r.top < vh + 600 && r.bottom > -600;
            if (!near) {
                if (!el.hasAttribute("data-bw-lazy")) {
                    el.setAttribute("data-bw-lazy", "");
                    bwSliderIO.observe(el);
                }
                continue;
            }
            bwSliderIO.unobserve(el);
        }
        await yieldToMain();
        bwInitCollectionSlider(el);
    }
});





// part 3

const listProductSliderEvt = new CustomEvent("listProductSlider");
let l4prDelegatesAttached = !1;
function l4prClick(element) {
    const idx = parseInt(element.dataset.l4prIndex, 10);
    if (isNaN(idx)) return;
    const m6 = element.closest(".m6pr");
    const s = m6
        ? m6.querySelector(".l4pr.s4wi")?.children[0]?.swiper
        : document.querySelector(".l4pr.s4wi")?.children[0]?.swiper;
    if (s) s.slideTo(idx);
}
function attachL4prDelegates() {
    if (l4prDelegatesAttached) return;
    l4prDelegatesAttached = !0;
    document.addEventListener("click", function (e) {
        if (e.target.tagName.toLowerCase() === "option") return;
        const l = e.target.closest("[data-l4pr-index]");
        if (l) l4prClick(l);
        if (e.target.tagName.toLowerCase() === "a" && e.target.classList.contains("swiper-pagination-bullet")) {
            const slide = e.target.closest(".swiper-slide");
            if (slide) {
                getSiblings(slide).forEach((s) => {
                    if (s.firstElementChild) s.firstElementChild.classList.remove("swiper-pagination-bullet-active");
                });
                e.target.classList.add("swiper-pagination-bullet-active");
            }
            e.preventDefault();
        }
    });
    document.addEventListener("change", function (e) {
        if (e.target.tagName.toLowerCase() !== "select") return;
        const o = e.target.options[e.target.selectedIndex];
        if (o) l4prClick(o);
    });
}
window.addEventListener("listProductSlider", (event) => {
    const list = document.querySelectorAll(".l4pr");
    if (!list.length) return;
    html_tag.classList.add("t1pr");
    attachL4prDelegates();
    for (let el of list) {
        if (el.classList.contains("s4wi") || el.classList.contains("l4pr-initialized")) continue;
        el.classList.add("l4pr-initialized");
        let hsn = !1,
            sn = [];
        if (el.classList.contains("static")) {
            const cm = el.cloneNode(!0);
            cm.classList.remove("static");
            cm.classList.add("desktop-hide");
            el.classList.add("desktop-only");
            el.after(cm);
            el = el.nextElementSibling;
        }
        const mse = el,
            ch = [...mse.children],
            total = ch.length,
            is = parseFloat(el.getAttribute("data-featured_media_position") || 1) - 1;
        const sns = [...mse.querySelectorAll("li.sticky")];
        if (sns.length) {
            hsn = !0;
            sn = sns;
            sns.forEach((c) => c.remove());
        }
        mse.querySelectorAll("a > .model-3d:first-child model-viewer[poster]").forEach((em) => {
            const ps = em.getAttribute("poster");
            if (!ps) return;
            const w = createElementWithClass("picture", "just-poster"),
                i = document.createElement("img");
            i.src = i.dataset.src = ps;
            const alt = em.getAttribute("alt");
            if (alt) i.alt = alt;
            w.prepend(i);
            const cl = em.closest("a");
            if (cl) cl.prepend(w);
        });
        if (!el.classList.contains("thumbs-static") && !el.classList.contains("thumbs-slider") && ch[4]) {
            ch[4].classList.add("more");
            append_url(ch[4], "+" + (ch.length - 5), "more");
        }
        const slides = [...mse.cloneNode(!0).children];
        [...el.getElementsByClassName("m6bx")].forEach((em) => {
            em.classList.add("m6bx-inside");
            el.firstElementChild.appendChild(em);
            em.remove();
        });
        randomize(el);
        const rid = el.getAttribute("data-random");
        const snh = (s) => {
            const h = `${s.height}px`;
            if (s.navigation.prevEl) s.navigation.prevEl.style.height = h;
            if (s.navigation.nextEl) s.navigation.nextEl.style.height = h;
        };
        create_slider(mse, {
            direction: "horizontal",
            loop: !1,
            autoHeight: !0,
            preloadImages: !1,
            initialSlide: is,
            pagination: {
                el: `.swiper-pagination-${rid}`,
                clickable: !0,
                renderBullet: (idx, cn) => {
                    const fs = createElementWithClass("a", cn),
                        sc = slides[idx].className || "";
                    ["portrait", "landscape", "square", "stripe"].forEach((o) => {
                        if (sc.includes(o)) fs.classList.add(`orientation-${o}`);
                    });
                    if (sc.includes("auto")) {
                        fs.classList.add("auto");
                        fs.classList.remove("landscape", "portrait");
                    }
                    const img = slides[idx].querySelector("picture,img");
                    if (img) {
                        const at = img.closest("a[data-gallery-thumb]");
                        if (at) {
                            const ti = document.createElement("img");
                            ti.src = at.getAttribute("data-gallery-thumb");
                            ti.loading = "lazy";
                            ti.alt = "Thumbnail";
                            const tp = document.createElement("picture");
                            const pe = at.querySelector("picture[class]");
                            if (pe) tp.className = pe.className;
                            tp.appendChild(ti);
                            fs.appendChild(tp);
                        } else fs.appendChild(img);
                    }
                    const df = document.createElement("span"),
                        ml = slides[idx].querySelector("a.more");
                    if (ml && ch.length - 1 - idx > 0) {
                        const sp = document.createElement("span");
                        sp.innerText = "+" + (ch.length - 1 - idx);
                        df.appendChild(sp);
                        fs.classList.add("has-more");
                        slides[idx]
                            .querySelectorAll("a[data-fancybox]")
                            .forEach((em) => fs.setAttribute("href", em.getAttribute("href")));
                    }
                    const ic = slides[idx].querySelector("i[class^=icon-]");
                    if (ic) df.appendChild(ic);
                    fs.appendChild(df);
                    return fs.outerHTML;
                },
            },
            navigation: {
                nextEl: `[data-random="${rid}"] .swiper-button-next`,
                prevEl: `[data-random="${rid}"] .swiper-button-prev`,
            },
            on: {
                activeIndexChange() {
                    const cnt = this.slides ? this.slides.length : ch.length;
                    [...this.el.parentNode.getElementsByClassName("custom-progressbar-inner")].forEach(
                        (b) => (b.style.width = `${(100 * (this.activeIndex + 1)) / cnt}%`)
                    );
                },
                afterInit(s) {
                    const pb = createElementWithClass("div", "custom-progressbar"),
                        pbi = createElementWithClass("div", "custom-progressbar-inner");
                    pbi.style.width = `${100 / ch.length}%`;
                    pb.appendChild(pbi);
                    s.el.appendChild(pb);
                    [...s.el.querySelectorAll(".s1lb,.label")].forEach((em) => s.el.parentNode.appendChild(em));
                    [...s.el.getElementsByClassName("m6bx-inside")].forEach((em) => s.el.appendChild(em));
                    if (el.classList.contains("no-thumbs-mobile") || el.classList.contains("slider-fraction")) {
                        const cf = s.el.parentNode.querySelector(".swiper-custom-fraction");
                        const cur = createElementWithClass("span", "swiper-pagination-current");
                        cur.textContent = "1";
                        const sl = createElementWithClass("span", "slash");
                        sl.textContent = "/";
                        const tot = createElementWithClass("span", "total-el");
                        tot.textContent = s.slides.length;
                        cf.append(cur, document.createTextNode(" "), sl, document.createTextNode(" "), tot);
                    }
                    setTimeout(() => snh(s), 300);
                },
                slideChangeTransitionEnd(s) {
                    setTimeout(() => snh(s), 300);
                },
                slideChangeTransitionStart(s) {
                    setTimeout(() => {
                        const cnt = s.slides ? s.slides.length : total;
                        if (el.classList.contains("no-thumbs-mobile") || el.classList.contains("slider-fraction")) {
                            const cf = s.el.parentNode.querySelector(".swiper-pagination-current");
                            cf.innerHTML = s.realIndex + 1;
                            s.el.classList.toggle("changed", s.realIndex > 0);
                        }
                        s.el.classList.toggle("last-slide-active", s.realIndex + 1 === cnt);
                    }, 300);
                },
                resize(s) {
                    snh(s);
                },
            },
        });
        if (hsn)
            sn.forEach((n) => {
                const so = el.querySelector(".swiper-outer");
                (so || el).appendChild(n);
            });
        if (el.classList.contains("thumbs-slider")) {
            const bs = `[data-random="${rid}"] .swiper-pagination-bullets`,
                cb = el.querySelector(bs);
            clone_with_class(cb, "cloned", "hidden");
            const clb = el.querySelector(`${bs}.cloned`);
            [...clb.children].forEach((c, i) => (c.dataset.l4prIndex = i));
            create_slider(clb, {
                direction: "horizontal",
                loop: !1,
                autoHeight: !1,
                slidesPerView: "auto",
                navigation: { nextEl: `${bs} .swiper-button-next`, prevEl: `${bs} .swiper-button-prev` },
            });
        }
    }
});


// const selectTagEvt = new CustomEvent("selectTag");
// window.addEventListener("selectTag", function () {
//     const tags = document.getElementsByTagName("select");
//     if (!tags.length) return;
//     for (const el of tags) {
//         if (el.parentNode) el.parentNode.classList.add("has-select");
//         el.closest("p")?.classList.add("has-select");
//         el.addEventListener("change", () => {
//             if (!el.classList.contains("changed")) el.classList.add("changed");
//         });
//     }
// });

const selectTagEvt = new CustomEvent("selectTag");

let selectInitialized = false;

window.addEventListener("selectTag", function () {
    if (selectInitialized) return;
    selectInitialized = true;

    const tags = document.getElementsByTagName("select");
    if (!tags.length) return;

    for (let i = 0; i < tags.length; i++) {
        const el = tags[i];

        const parent = el.parentNode;
        if (parent) parent.classList.add("has-select");

        const p = el.closest("p");
        if (p) p.classList.add("has-select");

        el.addEventListener("change", () => {
            el.classList.add("changed");
        }, { passive: true });
    }
});




// const formZindexEvt = new CustomEvent("formZindex");
// window.addEventListener("formZindex", function () {
//     window.dispatchEvent(selectTagEvt);
//     let calculated = !1;
//     function run() {
//         runWhenIdle(() => {
//             if (calculated) return;
//             requestAnimationFrame(() => {
//                 const els = document.querySelectorAll(
//                     "form > *, fieldset > *, .no-zindex, .no-zindex > *, .has-select, .f8pr > *, .l4ca.compact.in-panel > *, .l4cl.box > li, .f8pr-bulk > *"
//                 );
//                 if (els.length) assignIndex(els);
//                 calculated = !0;
//             });
//         });
//     }
//     window.addEventListener(
//         "resize",
//         throttle(() => {
//             calculated = !1;
//             run();
//         }, 500)
//     );
//     run();
// });


const formZindexEvt = new CustomEvent("formZindex");

let zindexCalculated = false;
let resizeBound = false;

window.addEventListener("formZindex", function () {
    window.dispatchEvent(selectTagEvt);

    function run() {
        if (zindexCalculated) return;

        requestAnimationFrame(() => {
            const els = document.querySelectorAll(
                "form > *, fieldset > *, .no-zindex, .no-zindex > *, .has-select, .f8pr > *, .l4ca.compact.in-panel > *, .l4cl.box > li, .f8pr-bulk > *"
            );

            if (els.length) {
                assignIndex(els);
            }

            zindexCalculated = true;
        });
    }

    if (!resizeBound) {
        resizeBound = true;

        window.addEventListener("resize", throttle(() => {
            zindexCalculated = false;
            run();
        }, 500), { passive: true });
    }

    run();
});





// Part 3


/*! Async Resources -------------------------------------------------- */
const outline_js = fp("js/plugin-outline.js", "plugin_outline_js");
const css_async = fp("styles/async.css", "async_css");
const css_menu = fp("styles/async-menu.css", "async_menu_css");
const css_hovers = fp("styles/async-hovers.css", "async_hovers_css");
const css_hovers_hack = fp("styles/async-hovers-hack.css", "async_hovers_hack_css");
const validation_css = fp("styles/async-validation.css", "async_validation_css");
const isFakeNoHover =
    navigator.maxTouchPoints > 0 &&
    window.matchMedia("(pointer: fine)").matches &&
    !window.matchMedia("(hover: hover)").matches;
let asyncCSSLoaded = !1;
// function asyncCSS() {
//     if (asyncCSSLoaded) return;
//     new_css("async-css", css_async);
//     new_css("hovers-css", css_hovers);
//     if (isFakeNoHover) new_css("hovers-hack-css", css_hovers_hack);
//     new_css("menu-css", css_menu);
//     loadRes(outline_js, () => {}, "outline-loaded");
//     asyncCSSLoaded = !0;
//     const skip = document.getElementById("skip");
//     if (skip && nav_bar_id) {
//         const l = skip.querySelector('a[href="#nav"]');
//         if (l) l.setAttribute("href", "#nav-bar");
//     }
// }

function asyncCSS() {
    if (asyncCSSLoaded) return;
    asyncCSSLoaded = true;

    requestAnimationFrame(() => {
        new_css("async-css", css_async);
        new_css("hovers-css", css_hovers);

        if (isFakeNoHover) {
            new_css("hovers-hack-css", css_hovers_hack);
        }

        new_css("menu-css", css_menu);

        loadRes(outline_js, () => {}, "outline-loaded");

        const skip = document.getElementById("skip");
        if (skip && nav_bar_id) {
            const l = skip.querySelector('a[href="#nav"]');
            if (l) {
                l.setAttribute("href", "#nav-bar");
            }
        }
    });
}

["mousedown", "keydown", "touchstart"].forEach((t) => window.addEventListener(t, asyncCSS, { once: !0, passive: !0 }));
document.addEventListener("keyup", asyncCSS, asyncOnce);
document.addEventListener("touchstart", asyncCSS, asyncPass);
document.addEventListener("pointerdown", asyncCSS, asyncPass);
document.addEventListener("scroll", asyncCSS, asyncPass);

let touchMoving = !1,
    lastScrollY = window.scrollY,
    scrollCheckTimeout;
/* INP optimization: "touch-moving" promotes the header to its own compositor layer
   (html.touch-moving .shopify-section-header { will-change: transform }). It used to be added on every
   touchstart, so each plain tap created and then destroyed that layer right around the click's paint.
   It is now added on the first touchmove of a gesture, i.e. only when the finger actually scrolls;
   removal after the scroll settles is unchanged. */
window.addEventListener(
    "touchmove",
    () => {
        if (touchMoving) return;
        touchMoving = !0;
        requestAnimationFrame(() => {
            if (touchMoving) html_tag.classList.add("touch-moving");
        });
    },
    { passive: !0 }
);
window.addEventListener(
    "touchend",
    () => {
        if (!touchMoving) return;
        if (scrollCheckTimeout) cancelAnimationFrame(scrollCheckTimeout);
        // const check = () => {
        //     const y = window.scrollY;
        //     if (Math.abs(y - lastScrollY) < 2) {
        //         touchMoving = !1;
        //         html_tag.classList.remove("touch-moving");
        //     } else {
        //         lastScrollY = y;
        //         scrollCheckTimeout = requestAnimationFrame(check);
        //     }
        // };

        const check = () => {
            requestAnimationFrame(() => {
                const y = window.scrollY;

                if (Math.abs(y - lastScrollY) < 2) {
                    touchMoving = false;
                    html_tag.classList.remove("touch-moving");
                } else {
                    lastScrollY = y;
                    scrollCheckTimeout = requestAnimationFrame(check);
                }
            });
        };


        lastScrollY = window.scrollY;
        scrollCheckTimeout = requestAnimationFrame(check);
    },
    { passive: !0 }
);



/*! ============================================================
 *  Staggered dispatch — التعديل الرئيسي لتخفيض TBT
 *  كل event بيتنفذ في task منفصل بفارق زمني
 *  عشان المتصفح يقدر يتنفس بين كل مهمة
 * ============================================================ */
setTimeout(() => window.dispatchEvent(inputPaddingsEvt), 0);
setTimeout(() => window.dispatchEvent(moduleFeaturedSliderEvt), 50);
setTimeout(() => window.dispatchEvent(listCollectionEvt), 100);
setTimeout(() => window.dispatchEvent(listCollectionSliderEvt), 150);
setTimeout(() => window.dispatchEvent(listProductSliderEvt), 200);
setTimeout(() => window.dispatchEvent(listTestimonialsSliderEvt), 250);
setTimeout(() => window.dispatchEvent(listStaticSliderEvt), 300);
setTimeout(() => window.dispatchEvent(listUspSliderEvt), 350);
setTimeout(() => window.dispatchEvent(ratingsEvt), 400);
setTimeout(() => window.dispatchEvent(mediaFlexibleEvt), 450);
setTimeout(() => window.dispatchEvent(createColsEvt), 500);
setTimeout(() => window.dispatchEvent(lazyVideoEvt), 550);
setTimeout(() => window.dispatchEvent(check_limit_event), 600);
runWhenIdle(() => window.dispatchEvent(moduleTabsEvt));
runWhenIdle(() => window.dispatchEvent(formZindexEvt));
const custom_async_js = fp("js/custom-async.js", "custom_async_js");
runWhenIdle(() => loadRes(custom_async_js, () => {}, "custom-async-loaded"));
/*! Image Loading Optimizer ----------------------------------------*/
(function initImageOptimizer() {
    const firstImg = document.querySelector(".shopify-section-header ~ * img, #content > *:first-child img");
    if (firstImg && !firstImg.closest('[loading="lazy"]')) {
        firstImg.fetchPriority = "high";
        firstImg.decoding = "sync";
    }
    const belowFoldObs = new IntersectionObserver(
        (entries, obs) => {
            for (const entry of entries) {
                const img = entry.target;

                // Skip eager images
                if (img.classList.contains("no-lazy")) {
                    obs.unobserve(img);
                    continue;
                }


                if (!img.hasAttribute("loading")) {
                    img.setAttribute("loading", "lazy");
                }
                obs.unobserve(img);
            }
        },
        { rootMargin: "0px", threshold: 0 }
    );
    const lazySrcObs = new IntersectionObserver(
        (entries, obs) => {
            for (const entry of entries) {

                if (!entry.isIntersecting) continue;

                const img = entry.target;

                // Skip images that should stay eager
                if (img.classList.contains("no-lazy")) {
                    obs.unobserve(img);
                    continue;
                }
                
                if (img.dataset.srcset) {
                    img.srcset = img.dataset.srcset;
                    delete img.dataset.srcset;
                }
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    delete img.dataset.src;
                }
                img.classList.remove("lazy", "lazyload");
                obs.unobserve(img);
            }
        },
        { rootMargin: "300px 0px", threshold: 0 }
    );
    const lazySourceObs = new IntersectionObserver(
        (entries, obs) => {
            for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                const picture = entry.target;
                for (const source of picture.querySelectorAll("source[data-srcset]")) {
                    source.srcset = source.dataset.srcset;
                    delete source.dataset.srcset;
                }
                const img = picture.querySelector("img[data-src]");
                if (img) {
                    img.src = img.dataset.src;
                    delete img.dataset.src;
                }
                obs.unobserve(picture);
            }
        },
        { rootMargin: "300px 0px", threshold: 0 }
    );
    function handleImg(img) {
        if (img.dataset.src || img.dataset.srcset) {
            lazySrcObs.observe(img);
            return;
        }
        if (!img.dataset.observed) {
            img.dataset.observed = "1";
            belowFoldObs.observe(img);
        }
    }
    function handlePicture(pic) {
        if (pic.querySelector("source[data-srcset]")) {
            lazySourceObs.observe(pic);
        }
    }
    function scanImages() {
        for (const img of document.querySelectorAll("img")) handleImg(img);
        for (const pic of document.querySelectorAll("picture")) handlePicture(pic);
    }
    scanImages();

    /* INP optimization: every DOM insertion (cart drawer render, search results, slider setup,
       variant change) used to queue a full document scan of all <img> and <picture> elements, with
       no de-duplication. Only the inserted subtrees are scanned now, in one idle callback per batch.
       The per-image handling is unchanged. */
    const addedImgRoots = new Set();
    let addedImgScanQueued = !1;
    function scanAddedImages() {
        addedImgScanQueued = !1;
        const roots = Array.from(addedImgRoots);
        addedImgRoots.clear();
        for (const node of roots) {
            if (!node.isConnected) continue;
            const tag = node.nodeName;
            if (tag === "IMG") handleImg(node);
            else if (tag === "PICTURE") handlePicture(node);
            else if (tag === "SOURCE" && node.parentElement?.nodeName === "PICTURE") handlePicture(node.parentElement);
            if (!node.firstElementChild) continue;
            for (const img of node.querySelectorAll("img")) handleImg(img);
            for (const pic of node.querySelectorAll("picture")) handlePicture(pic);
        }
    }
    const imgMutObs = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (node.nodeType === 1) addedImgRoots.add(node);
            }
        }
        if (addedImgScanQueued || !addedImgRoots.size) return;
        addedImgScanQueued = !0;
        "requestIdleCallback" in window
            ? requestIdleCallback(scanAddedImages, { timeout: 1000 })
            : setTimeout(scanAddedImages, 300);
    });



    imgMutObs.observe(document.body, { childList: !0, subtree: !0 });
    const cdnLink = document.createElement("link");
    cdnLink.rel = "preconnect";
    cdnLink.href = "https://cdn.shopify.com";
    cdnLink.crossOrigin = "anonymous";
    if (!document.querySelector('link[href*="cdn.shopify.com"]')) {
        document.head.appendChild(cdnLink);
    }
})();

